<template>
  <div>
    <QuizForm v-if="currentQuiz" :quiz="currentQuiz" />
  </div>
</template>

<script>
import QuizForm from "@/components/quiz/QuizForm.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "Quiz",
  components: {
    QuizForm,
  },
  computed: {
    ...mapState("quizzes", ["currentQuiz"]),
  },
  created() {
    this.fetchQuiz(this.$route.params.quizId);
  },
  methods: {
    ...mapActions("quizzes", ["fetchQuiz"]),
  },
};
</script>
